import idx from 'idx';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleEditEntries } from 'focus_groups/ducks/view_state';
import { setCurrentRevision } from 'focus_groups/ducks/results';

import Results from 'focus_groups/components/results';

export function mapStateToProps(state) {
  const { currentGroup, showEditEntries } = idx(state, _ => _.project.focusGroups.viewState) || {};
  return { group: currentGroup, showEditEntries };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setCurrentRevision,
    toggleEditEntries,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Results);



// WEBPACK FOOTER //
// ./focus_groups/containers/results.js